export default "__VITE_ASSET__D0Ibe4ag__"